import React from 'react'

const Details = () => {
return (
    <div className="details">
        <h2>Professional Summary:</h2>
        <p>
        Frontend Lead with 8+ years of experience driving end-to-end web
development and frontend excellence. Proven track record of
architecting and delivering scalable, high-performance, secure web
platforms from concept to production and derived UI/UX excellence
and build highly scalable frontend applications. Expert in building
and leading high-impact frontend teams, designing enterprisegrade UI systems, and shaping long-term architectural strategy.
Recognized for mentoring engineers, influencing cross-functional
stakeholders, and translating business vision into robust technical
solutions and Passionate about continuous learning, innovation, and
leading digital transformation at scale
        </p>
        <h2>Technical Skills:</h2>
        <p>
            <strong>Technologies:</strong> React js, JavaScript, ES6, TypeScript, HTML5, CSS3, Redux, Context API, Hooks, JSX, Virtual DOM, React Router, Jest, Unit Testing, Ant Design, Material-UI, REST API, SQL, Webpack, Babel, Micro Front-End, CI/CD, Next.js, Python, Git, GitHub, JIRA, Azure DevOps, AWS, Docker, Agile, Scrum, SDLC, Visual Studio Code, Postman, Firebase, MySql WorkBench, SonarQube, Lighthouse, Figma.<br /><br />
        </p>
        <h2>EXPERIENCE:</h2>
        <section className="experience">
            <p>
            <strong>Synechron Technologies- Bangalore</strong><br />
            Engineering Lead<br />
            July 2025 - Present
        </p>
        <p>
            <strong>Persistent System- Bangalore</strong><br />
            Engineering Lead<br />
            June 2024 - July 2025
        </p>
        <p>
            <strong>TNQ TECH - Chennai</strong><br />
            Senior Software Engineer<br />
            May 2022 - June 2024
        </p>
        <p>
            <strong>SPS - Chennai</strong><br />
            Senior Software Programmer<br />
            June 2019 - May 2022
        </p>
        <p>
            <strong>RR DONNELLY - Chennai</strong><br />
            Software Engineer<br />
            Dec 2017 – June 2019
        </p>
        </section>
        <h2>EDUCATION:</h2>
        <p>
            B. Tech (IT)<br />
            BIT Campus, Anna University, Trichy<br />
            2013-2017
        </p>
        <h2>Project & Leadership Skills
:</h2>
        <ul>
            <li>Team Leadership</li>
            <li>Front-End Architecture Design</li>
            <li>Project Planning & Execution</li>
            <li>Scrum Master & Sprint Leadership</li>
            <li>Cross-functional Team Coordination</li>
            <li>End-to-End Project Delivery</li>
        </ul>
        <h2>Certifications:</h2>
        <ul>
            <li>Advanced React</li>
             <li>Agentic AI</li>
        </ul>
        {/* <h2>My Website:</h2>
        <ul>
            <li><a href='https://resume-muthupandi-raj.web.app/' target='_blank'>My Resume</a></li>
            <li><a href='https://qrcode-genrate.web.app/' target='_blank'>QR Code generated</a></li>
            <li><a href='https://weather-allcity.web.app/' target='_blank'>Weather</a></li>
            <li><a href='https://indian-gov-exam-questions.web.app/' target='_blank'>Indian Government Question and Answers</a></li>
            <li><a href='https://maxtaxitheni.in/' target='_blank'>MaxTaxi Theni</a></li>
            <li><a href='https://bmi-calcul.web.app/' target='_blank'>BMI</a></li>
            <li><a href='https://user-card-muthu.web.app/' target='_blank'>User Card</a></li>
            <li><a href='https://currency-convert-all.web.app/' target='_blank'>Currency Converter</a></li>
            <li><a href='https://bhiveworkspace-muthupandi.web.app/' target='_blank'>Bhive Workspace App</a></li>
        </ul>
        <h2>SOFT SKILLS:</h2>
        <ul>
            <li>Teamwork</li>
            <li>Self-learning</li>
            <li>Problem-solving</li>
            <li>Quick learner</li>
            <li>Leadership</li>
            <li>Responsibility</li>
        </ul> */}
    </div>
)
}

export default Details